import React, { useCallback } from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

import notfound from "../../img/404.svg";
import { NotFoundContainer } from "./NotFound.elements";
import Loading from "../Loading/Loading";
import useRooms from "../../hooks/use-rooms";

function NotFound() {
  const {rooms, isLoading} = useRooms();

  console.log(rooms, isLoading);

  const randomize = useCallback((array) => {
    const randomRooms = [];
    for (let i = 0; i < 3; i++) {
      const randomId = Math.floor(Math.random() * array.length);
      if (randomRooms.indexOf(array[randomId]) !== -1) {
        continue;
      }
      randomRooms.push(array[randomId]);
    }
    return randomRooms;
  }, []);

  return (
    <NotFoundContainer>
      <h1>NOT FOUND :(</h1>
      <img src={notfound} alt="notfound" />
      <h3>Randomly picked channels:</h3>
      {isLoading && <Loading />}
      {rooms.length > 0 && (
        <ul>
          {randomize(rooms)?.map((room) => (
            <li key={room.id}>
              <Button>
                <Link to={`/channel/${room.id}`}>{room.name}</Link>
              </Button>
            </li>
          ))}
        </ul>
      )}
    </NotFoundContainer>
  );
}

export default NotFound;
